import React from 'react';
import ContentBannerV2 from '@ajat/design-system/ContentBlocks/ContentBannerV2';
import { ComponentPage, DemoCard } from '../../shared';
import { KVALITE, BORJA_DESIGNA } from './contentDemoData';

export const meta = {
  component: ContentBannerV2,
  title: 'Content Banner V2',
  group: 'Content Blocks',
  importPath: '@ajat/design-system/ContentBlocks/ContentBannerV2',
  figmaNode: '2217:151813',
  description:
    'Dark two-column banner (OVER-LL). The text column carries an eyebrow, editorial title, paragraph, a check-list (features) and/or numbered steps and a CTA. The visual follows the data: 2+ images → a 2×2 mosaic of dark cards with staggered tops (a sideways scroller on mobile); 1 image or a video → one large preview card that stickers may hang over. `reversed` (Figma 2275:15287) puts the text left and the visual right.',
  props: [
    ['visualPosition', "'start' | 'end'", "'start'", 'Desktop side of the visual — the DS name shared with ContentBanner / HeroBannerV3'],
    ['reversed', 'bool', 'false', 'Deprecated — the old spelling of visualPosition="end"'],
    ['visual', "'auto' | 'mosaic' | 'preview'", "'auto'", 'auto: 2+ images → mosaic, else preview; or force one (the mosaic is styled for exactly 4 images)'],
    ['subtitle', 'string', "''", 'Eyebrow: 24px rule + uppercase text'],
    ['title', 'string', "''", 'Title (typo-h1-editorial)'],
    ['paragraph', 'string', "''", 'Paragraph under the title'],
    ['paragraphVariant', "'large' | 'editorial'", "'large'", 'P.Large gray-6, or P.Editorial gray-5'],
    ['features', 'array', '[]', '[{ title, description }] check-list'],
    ['steps', 'array', '[]', 'Numbered steps (strings)'],
    ['ctaLabel', 'string', "''", 'CTA label (Button secondary)'],
    ['ctaVariant', 'string', "'gray'", 'CTA Button variant'],
    ['ctaIcon', 'node', '—', 'CTA icon'],
    ['ctaHref', 'string', '—', 'CTA link target — renders it as a real link'],
    ['ctaOnClick', 'func', '—', 'CTA handler'],
    ['images', 'array', '[]', '[{ src, srcMobile, alt }] — 2+ → mosaic, 1 → preview card'],
    ['video', 'string', '—', 'Preview-card video; images[0] is its poster'],
    ['stickers', 'array', '[]', "[{ src, alt, position: 'top-left' | 'top-right' }] over the preview card"],
    ['className', 'string', "''", 'Additional CSS class'],
  ],
  usage: [
    {
      title: 'Mosaic + check-list (Kvalité)',
      code: `<ContentBannerV2
  subtitle="Kvalité"
  title="Byggd för att hålla"
  paragraph="Vi kompromissar inte med kvalitet. …"
  features={[{ title: '350g premium canvas', description: 'Tung, strukturerad, vacker' }]}
  images={[{ src: pocket }, { src: chest }, { src: lining }, { src: button }]}
/>`,
    },
    {
      title: 'Reversed: steps + preview card (Börja designa)',
      code: `<ContentBannerV2
  reversed
  title="Börja designa"
  paragraph="Välj din bas. Placera dina patchar. Se resultatet i realtid."
  paragraphVariant="editorial"
  steps={['Välj basfärg och modell', 'Lägg till patchar från Patch Universe']}
  ctaLabel="Designa nu"
  ctaOnClick={() => navigate('/overalls/configurator')}
  images={[{ src: configuratorWide, srcMobile: configuratorTall }]}
  stickers={[{ src: baddie, position: 'top-left' }, { src: lifeSucks, position: 'top-right' }]}
/>`,
    },
  ],
};

export default function ContentBannerV2Page() {
  return (
    <ComponentPage meta={meta}>
      <DemoCard title="Mosaic + check-list" hint="Figma 2217:151813 · visual left" flush>
        <ContentBannerV2 {...KVALITE} />
      </DemoCard>
      <DemoCard title="Reversed: steps + preview card" hint="Figma 2275:15287 · text left" flush>
        <ContentBannerV2 reversed paragraphVariant="editorial" {...BORJA_DESIGNA} />
      </DemoCard>
    </ComponentPage>
  );
}
